module.exports = __webpack_public_path__ + "img/multiOrange.50db13ae.jpg";